(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3873],{

/***/ 92508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ BulletedList; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var BulletedList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "BulletedList",
  componentId: "sc-1sbizlb-0"
})(["font-size:16px;line-height:1.3;list-style:", ";margin-left:24px;display:flex;flex-direction:column;gap:21px;> li::marker{color:", ";}@media screen and (max-width:1047px){font-size:15px;line-height:1.6;gap:12px;}"], function (_ref) {
  var listStyle = _ref.listStyle;
  return listStyle !== null && listStyle !== void 0 ? listStyle : 'disc';
}, function (_ref2) {
  var listStyle = _ref2.listStyle;
  return listStyle === 'decimal' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.grey */ .r.colors.grey;
});

/***/ }),

/***/ 75939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ DisclosurePage; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Ir/index.tsx
var Ir = __webpack_require__(87661);
// EXTERNAL MODULE: ./src/components/layouts/Ir/BulletedList.tsx
var BulletedList = __webpack_require__(92508);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Heading.tsx
var Heading = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(45775);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Manage/Disclosure/index.tsx












var DisclosurePage = function DisclosurePage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      titleText: "Disclosure / IR Policy",
      subTitleText: "\u30C7\u30A3\u30B9\u30AF\u30ED\u30FC\u30B8\u30E3\u30FC\u30FBIR\u30DD\u30EA\u30B7\u30FC"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "\u30C7\u30A3\u30B9\u30AF\u30ED\u30FC\u30B8\u30E3\u30FC\u30FB\u30DD\u30EA\u30B7\u30FC"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u79C1\u305F\u3061\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u6D41\u901A\xD7IT \u306E\u7D44\u307F\u5408\u308F\u305B\u306B\u3088\u3063\u3066\u3001\u30EA\u30C6\u30FC\u30EB DX \u3092\u63A8\u9032\u3057\u3066\u3001\u6D41\u901A\u9769\u547D\u3092\u8D77\u3053\u3059\u3053\u3068\u3092\u76EE\u6307\u3057\u3066\u3044\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u300E\u4E16\u754C\u306E\u8AB0\u3082\u304C\u300C\u8C4A\u304B\u3055\u300D\u3092\u4EAB\u53D7\u3067\u304D\u308B\u793E\u4F1A\u3092\u3064\u304F\u308B\u3002\u300F\u3092\u30D1\u30FC\u30D1\u30B9\u306B\u63B2\u3052\u3066\u3001\u79C1\u305F\u3061\u306F\u30B9\u30C6\u30FC\u30AF\u30DB\u30EB\u30C0\u30FC\u306E\u7686\u3055\u307E\u306B\u5BFE\u3057\u3066\u3001\u8FC5\u901F\u3001\u6B63\u78BA\u304B\u3064\u516C\u5E73\u306A\u30C7\u30A3\u30B9\u30AF\u30ED\u30FC\u30B8\u30E3\u30FC\u3092\u5B9F\u884C\u3057\u306A\u304C\u3089\u3001\u5EFA\u8A2D\u7684\u306A\u5BFE\u8A71\u306B\u52AA\u3081\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u305D\u306E\u7D99\u7D9A\u306B\u3088\u308A\u3001\u7D4C\u55B6\u306E\u900F\u660E\u6027\u3092\u9AD8\u3081\u308B\u3068\u540C\u6642\u306B\u3001\u4F01\u696D\u306E\u793E\u4F1A\u7684\u8CAC\u4EFB\u3092\u679C\u305F\u3057\u306A\u304C\u3089\u3001\u4FE1\u983C\u3044\u305F\u3060\u3051\u308B\u3088\u3046\u306B\u52AA\u3081\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u3053\u306E\u57FA\u672C\u65B9\u91DD\u3092\u793E\u5185\u5916\u306B\u5468\u77E5\u3059\u308B\u3068\u3068\u3082\u306B\u3001\u81EA\u3089\u306E\u30C7\u30A3\u30B9\u30AF\u30ED\u30FC\u30B8\u30E3\u30FC\u3092\u5E38\u306B\u3001\u9069\u6B63\u306A\u57FA\u6E96\u3001\u65B9\u6CD5\u3001\u4F53\u5236\u3067\u5B9F\u884C\u3059\u308B\u305F\u3081\u306B\u3001\u30C7\u30A3\u30B9\u30AF\u30ED\u30FC\u30B8\u30E3\u30FC\u30FB\u30DD\u30EA\u30B7\u30FC\u3092\u4EE5\u4E0B\u306E\u901A\u308A\u5B9A\u3081\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 50,
          pc: 80
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "1. \u60C5\u5831\u958B\u793A\u306E\u57FA\u6E96"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u5F53\u793E\u306F\u3001\u4F1A\u793E\u6CD5\u3001\u91D1\u878D\u5546\u54C1\u53D6\u5F15\u6CD5\u305D\u306E\u4ED6\u8AF8\u6CD5\u4EE4\u306A\u3089\u3073\u306B\u6771\u4EAC\u8A3C\u5238\u53D6\u5F15\u6240\u306E\u300C\u6709\u4FA1\u8A3C\u5238\u4E0A\u5834\u898F\u7A0B\u300D\u306B\u5B9A\u3081\u308B\u4F1A\u793E\u60C5\u5831\u306E\u9069\u6642\u958B\u793A\u306B\u95A2\u3059\u308B\u898F\u5B9A\uFF08\u4EE5\u4E0B\u3001\u300C\u9069\u6642\u958B\u793A\u898F\u5247\u300D\uFF09\u306B\u57FA\u3065\u304F\u4E00\u8CAB\u3057\u305F\u60C5\u5831\u958B\u793A\u3092\u884C\u3044\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u6295\u8CC7\u5224\u65AD\u306B\u91CD\u8981\u306A\u5F71\u97FF\u3092\u4E0E\u3048\u308B\u6C7A\u5B9A\u4E8B\u5B9F\u3001\u767A\u751F\u4E8B\u5B9F\u3001\u6C7A\u7B97\u306B\u95A2\u3059\u308B\u60C5\u5831\u304C\u751F\u3058\u305F\u5834\u5408\u306B\u306F\u3001\u9069\u6642\u958B\u793A\u898F\u5247\u306E\u57FA\u6E96\u306B\u6CBF\u3063\u3066\u8FC5\u901F\u306B\u958B\u793A\u3059\u308B\u3068\u3068\u3082\u306B\u3001\u9069\u6642\u958B\u793A\u898F\u5247\u306B\u8A72\u5F53\u3057\u306A\u3044\u5834\u5408\u3067\u3082\u3001\u30B9\u30C6\u30FC\u30AF\u30DB\u30EB\u30C0\u30FC\u306E\u65B9\u3005\u306B\u5F53\u793E\u3092\u7406\u89E3\u3044\u305F\u3060\u304F\u305F\u3081\u306B\u91CD\u8981\u3042\u308B\u3044\u306F\u6709\u76CA\u3067\u3042\u308B\u3068\u5224\u65AD\u3057\u305F\u60C5\u5831\u306B\u3064\u304D\u307E\u3057\u3066\u306F\u7A4D\u6975\u7684\u306B\u958B\u793A\u3057\u3001\u60C5\u5831\u30A2\u30AF\u30BB\u30B9\u306E\u516C\u5E73\u6027\u5411\u4E0A\u306B\u52AA\u3081\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u306A\u304A\u3001\u500B\u4EBA\u60C5\u5831\u3001\u9867\u5BA2\u60C5\u5831\u3001\u53CA\u3073\u95A2\u4FC2\u8005\u306E\u6A29\u5229\u3092\u4FB5\u5BB3\u3059\u308B\u3053\u3068\u306B\u306A\u308B\u60C5\u5831\u306B\u3064\u304D\u307E\u3057\u3066\u306F\u958B\u793A\u3057\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "2. \u60C5\u5831\u958B\u793A\u306E\u65B9\u6CD5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u9069\u6642\u958B\u793A\u898F\u5247\u306B\u8A72\u5F53\u3059\u308B\u60C5\u5831\u306B\u3064\u304D\u307E\u3057\u3066\u306F\u3001\u6771\u4EAC\u8A3C\u5238\u53D6\u5F15\u6240\u304C\u63D0\u4F9B\u3059\u308B\u300CTDnet\uFF08\u9069\u6642\u958B\u793A\u60C5\u5831\u4F1D\u9054\u30B7\u30B9\u30C6\u30E0\uFF09\u300D\u3078\u767B\u9332\u3057\u516C\u958B\u3057\u305F\u5F8C\u3001\u901F\u3084\u304B\u306B\u5F53\u793EWeb\u30B5\u30A4\u30C8\u306B\u63B2\u8F09\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u9069\u6642\u958B\u793A\u898F\u5247\u306B\u8A72\u5F53\u3057\u306A\u3044\u60C5\u5831\u306B\u3064\u304D\u307E\u3057\u3066\u3082\u3001Web\u30B5\u30A4\u30C8\u3078\u306E\u63B2\u8F09\u7B49\u306B\u3088\u308A\u5E83\u304F\u958B\u793A\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "3. \u30A4\u30F3\u30B5\u30A4\u30C0\u30FC\u53D6\u5F15\u306E\u672A\u7136\u9632\u6B62"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u5F53\u793E\u306F\u3001\u91CD\u8981\u60C5\u5831\u3092\u9069\u5207\u306B\u7BA1\u7406\u3057\u30A4\u30F3\u30B5\u30A4\u30C0\u30FC\u53D6\u5F15\u306E\u672A\u7136\u9632\u6B62\u3092\u56F3\u308B\u305F\u3081\u306E\u793E\u5185\u898F\u7A0B\u3092\u5B9A\u3081\u3001\u30B0\u30EB\u30FC\u30D7\u793E\u54E1\u5168\u4F53\u3078\u306E\u5468\u77E5\u5FB9\u5E95\u3068\u7406\u89E3\u5553\u8499\u3092\u4FC3\u9032\u3057\u3066\u3044\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "4. \u696D\u7E3E\u4E88\u60F3\u53CA\u3073\u5C06\u6765\u60C5\u5831\u306E\u53D6\u308A\u6271\u3044"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u5F53\u793E\u304C\u958B\u793A\u3059\u308B\u696D\u7E3E\u4E88\u60F3\u3001\u6226\u7565\u3001\u65B9\u91DD\u3001\u76EE\u6A19\u7B49\u306E\u3046\u3061\u3001\u6B74\u53F2\u7684\u4E8B\u5B9F\u3067\u306F\u306A\u3044\u3082\u306E\u306F\u5C06\u6765\u306E\u898B\u901A\u3057\u306B\u95A2\u3059\u308B\u8A18\u8FF0\u3067\u3042\u308A\u3001\u3053\u308C\u3089\u306F\u3001\u5F53\u793E\u304C\u305D\u306E\u6642\u70B9\u3067\u5165\u624B\u3057\u3066\u3044\u308B\u60C5\u5831\u53CA\u3073\u5408\u7406\u7684\u3067\u3042\u308B\u3068\u5224\u65AD\u3055\u308C\u308B\u4E00\u5B9A\u306E\u524D\u63D0\u306B\u57FA\u3065\u304F\u8A08\u753B\u3001\u671F\u5F85\u3001\u5224\u65AD\u3092\u6839\u62E0\u3068\u3057\u3066\u304A\u308A\u3001\u5B9F\u969B\u306E\u696D\u7E3E\u7B49\u306F\u69D8\u3005\u306A\u30EA\u30B9\u30AF\u3084\u4E0D\u78BA\u5B9A\u8981\u56E0\u306B\u3088\u308A\u5927\u304D\u304F\u7570\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "5. \u6C88\u9ED9\u671F\u9593"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u5F53\u793E\u306F\u3001\u30B9\u30C6\u30FC\u30AF\u30DB\u30EB\u30C0\u30FC\u306E\u65B9\u3005\u3078\u306E\u516C\u5E73\u6027\u3092\u78BA\u4FDD\u3059\u308B\u305F\u3081\u3001\u5404\u56DB\u534A\u671F\u306E\u671F\u672B\u65E5\u306E\u7FCC\u65E5\u304B\u3089\u5404\u6C7A\u7B97\u767A\u8868\u65E5\u307E\u3067\u3092\u6C88\u9ED9\u671F\u9593\u3068\u3057\u3066\u3044\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u3053\u306E\u671F\u9593\u4E2D\u306F\u3001\u6C7A\u7B97\u30FB\u696D\u7E3E\u898B\u901A\u3057\u306B\u95A2\u3059\u308B\u8CEA\u554F\u3078\u306E\u56DE\u7B54\u3084\u30B3\u30E1\u30F3\u30C8\u3092\u5DEE\u3057\u63A7\u3048\u3066\u304A\u308A\u307E\u3059\u3002\u305F\u3060\u3057\u3001\u6C88\u9ED9\u671F\u9593\u4E2D\u306B\u696D\u7E3E\u4E88\u60F3\u3092\u5927\u304D\u304F\u5916\u308C\u308B\u898B\u8FBC\u304C\u51FA\u3066\u304D\u305F\u3068\u304D\u306B\u306F\u3001\u9069\u6642\u958B\u793A\u898F\u5247\u306B\u5F93\u3044\u3001\u9069\u5B9C\u60C5\u5831\u958B\u793A\u3092\u884C\u3044\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "6. \u793E\u5185\u4F53\u5236\u306E\u6574\u5099\u306B\u3064\u3044\u3066"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u5F53\u793E\u306F\u30C7\u30A3\u30B9\u30AF\u30ED\u30FC\u30B8\u30E3\u30FC\u30FB\u30DD\u30EA\u30B7\u30FC\u3092\u9069\u5207\u306B\u904B\u7528\u3057\u3001\u9069\u6642\u958B\u793A\u898F\u5247\u306B\u57FA\u3065\u304F\u9069\u6642\u3001\u9069\u5207\u306A\u60C5\u5831\u958B\u793A\u3092\u5B9F\u884C\u3059\u308B\u4F53\u5236\u3092\u69CB\u7BC9\u3057\u7DAD\u6301\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u5F53\u793E\u306F\u3001\u60C5\u5831\u958B\u793A\u62C5\u5F53\u90E8\u9580\u304C\u793E\u5185\u306E\u5404\u696D\u52D9\u57F7\u884C\u90E8\u9580\u3068\u306E\u9023\u7E4B\u306B\u3088\u308A\u9069\u5207\u306A\u60C5\u5831\u53CE\u96C6\u3068\u5206\u6790\u3092\u884C\u3044\u3001\u4F1A\u793E\u3068\u3057\u3066\u9069\u5207\u306A\u5224\u65AD\u306E\u4E0A\u3067\u958B\u793A\u3092\u884C\u3046\u305F\u3081\u306B\u3001\u60C5\u5831\u306E\u767A\u751F\u304B\u3089\u958B\u793A\u306B\u81F3\u308B\u30D7\u30ED\u30BB\u30B9\u3092\u660E\u78BA\u5316\u3057\u3066\u3044\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 30
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: "/images/ir-timely-disclosure-system_JP.png",
        alt: "\u9069\u6642\u958B\u793A\u4F53\u5236",
        width: "100%"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 80,
          pc: 100
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "IR\u30DD\u30EA\u30B7\u30FC"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u5F53\u793E\u306F\u3001\u6D41\u901A\xD7IT\u306E\u7D44\u307F\u5408\u308F\u305B\u306B\u3088\u3063\u3066\u3001\u6D41\u901A\u5C0F\u58F2\u696D\u754C\u306E\u30E0\u30C0\u30FB\u30E0\u30E9\u30FB\u30E0\u30EA\u306E\u89E3\u6D88\u306B\u8CA2\u732E\u3057\u306A\u304C\u3089\u3001\u304A\u5BA2\u69D8\u306E\u5F79\u306B\u7ACB\u3064\u3068\u3044\u3046\u4F7F\u547D\u3092\u62C5\u3063\u3066\u3044\u307E\u3059\u3002\u5F53\u793E\u306EIR\u6D3B\u52D5\u306F\u3001\u682A\u4E3B\u3084\u6295\u8CC7\u5BB6\u306A\u3069\u3001\u30B9\u30C6\u30FC\u30AF\u30DB\u30EB\u30C0\u30FC\u306E\u7686\u3055\u307E\u306B\u5BFE\u3057\u3066\u3001\u8FC5\u901F\u3001\u6B63\u78BA\u304B\u3064\u516C\u5E73\u306A\u30C7\u30A3\u30B9\u30AF\u30ED\u30FC\u30B8\u30E3\u30FC\u3068\u5EFA\u8A2D\u7684\u306A\u5BFE\u8A71\u3092\u5B9F\u884C\u3059\u3079\u304F\u3001\u4E0B\u8A18\u65B9\u91DD\u306E\u3082\u3068\u306BIR\u6D3B\u52D5\u3092\u63A8\u9032\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u5F53\u793E\u306E\u4F01\u696D\u4FA1\u5024\u3092\u9AD8\u3081\u308B\u305F\u3081\u306B\u306F\u3001\u30B9\u30C6\u30FC\u30AF\u30DB\u30EB\u30C0\u30FC\u306E\u65B9\u3005\u306B\u5F53\u793E\u3092\u6B63\u3057\u304F\u3054\u7406\u89E3\u3044\u305F\u3060\u304F\u3053\u3068\u304C\u4E0D\u53EF\u6B20\u3067\u3059\u3002\u305D\u306E\u305F\u3081\u306B\u5F53\u793E\u306F\u3001\u7D4C\u55B6\u7406\u5FF5\u3001\u4F7F\u547D\u30FB\u5F79\u5272\u3001\u7D4C\u55B6\u65B9\u91DD\u3001\u4E8B\u696D\u5185\u5BB9\u3001\u696D\u7E3E\u3001\u8CA1\u52D9\u5185\u5BB9\u3001\u5404\u7A2E\u306E\u7D4C\u55B6\u6307\u6A19\u3001\u682A\u4E3B\u9084\u5143\u306E\u65B9\u91DD\u3068\u5B9F\u7E3E\u3001\u4E2D\u671F\u7D4C\u55B6\u8A08\u753B\u3068\u4ECA\u5F8C\u306E\u5C55\u671B\u7B49\u306B\u3064\u3044\u3066\u3001\u30C7\u30A3\u30B9\u30AF\u30ED\u30FC\u30B8\u30E3\u30FC\u30FB\u30DD\u30EA\u30B7\u30FC\u306B\u5247\u308A\u3001\u6B63\u3057\u304F\u3001\u30BF\u30A4\u30E0\u30EA\u30FC\u306B\u958B\u793A\u3044\u305F\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 20,
          pc: 30
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u306A\u3069\u30B9\u30C6\u30FC\u30AF\u30DB\u30EB\u30C0\u30FC\u306E\u7686\u3055\u307E\u3068\u306E\u5BFE\u8A71\u306F\u3001IR\u62C5\u5F53\u90E8\u9580\u53CA\u3073\u5404\u90E8\u9580\u306E\u7D4C\u55B6\u9663\u304C\u62C5\u3044\u307E\u3059\u3002\u5BFE\u8A71\u306E\u5B9F\u52B9\u6027\u3092\u9AD8\u3081\u308B\u305F\u3081\u3001IR\u62C5\u5F53\u90E8\u9580\u304C\u4E2D\u5FC3\u3068\u306A\u308A\u3001\u8CA1\u52D9\u30FB\u7D4C\u7406\u90E8\u9580\u3001\u7DCF\u52D9\u90E8\u9580\u7B49\u306E\u30B3\u30FC\u30DD\u30EC\u30FC\u30C8\u90E8\u9580\u3068\u5BC6\u63A5\u306A\u60C5\u5831\u9023\u643A\u3092\u56F3\u308A\u3001\u5EFA\u8A2D\u7684\u306A\u5BFE\u8A71\u306E\u524D\u63D0\u3068\u3057\u3066\u3001\u4EE5\u4E0B\u306E\u3088\u3046\u306A\u53D6\u7D44\u307F\u3092\u884C\u3044\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BulletedList/* BulletedList */.h, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "\u6C7A\u7B97\u8AAC\u660E\u4F1A\u3001\u4F1A\u793E\u8AAC\u660E\u4F1A\u3001\u65BD\u8A2D\u898B\u5B66\u4F1A\u306E\u5B9F\u65BD"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "\u6A5F\u95A2\u6295\u8CC7\u5BB6\u5411\u3051\u3001\u500B\u5225\u53D6\u6750\u306E\u5FDC\u5BFE"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "\u6C7A\u7B97\u30FB\u4F1A\u793E\u8AAC\u660E\u4F1A\u8CC7\u6599\u7B49\u3092\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3067\u516C\u8868"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u901A\u3058\u3066\u30B9\u30C6\u30FC\u30AF\u30DB\u30EB\u30C0\u30FC\u306E\u7686\u3055\u307E\u304B\u3089\u5F97\u3089\u308C\u305F\u77E5\u898B\u7B49\u306F\u3001\u7D4C\u55B6\u5224\u65AD\u306B\u5F79\u7ACB\u3066\u308B\u3088\u3046\u7D4C\u55B6\u9663\u306B\u968F\u6642\u5831\u544A\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "IR\u6D3B\u52D5\u3092\u901A\u3057\u3066\u3001\u30B9\u30C6\u30FC\u30AF\u30DB\u30EB\u30C0\u30FC\u306E\u7686\u3055\u307E\u306E\u5F53\u793E\u306B\u5BFE\u3059\u308B\u3054\u7406\u89E3\u3092\u9069\u5207\u306B\u6DF1\u3081\u3066\u3044\u305F\u3060\u304F\u3068\u3068\u3082\u306B\u3001\u5F53\u793E\u306E\u4F01\u696D\u4FA1\u5024\u3001\u30D6\u30E9\u30F3\u30C9\u4FA1\u5024\u306E\u5411\u4E0A\u3092\u76EE\u6307\u3057\u307E\u3059\u3002"
      })]
    })]
  });
};

DisclosurePage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '株主・投資家向け情報',
    path: '/ir'
  }, {
    name: '経営方針',
    path: '/ir/manage'
  }, {
    name: 'ディスクロージャー・IRポリシー',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u30C7\u30A3\u30B9\u30AF\u30ED\u30FC\u30B8\u30E3\u30FC\u30FBIR\u30DD\u30EA\u30B7\u30FC",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306EIR\u6D3B\u52D5\u306B\u304A\u3051\u308B\u57FA\u672C\u65B9\u91DD\u306B\u3064\u3044\u3066\u63B2\u8F09\u3057\u3066\u304A\u308A\u307E\u3059\u3002",
      ogp: {
        url: 'ir/manage/disclosure/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};

var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Disclosure__Image",
  componentId: "sc-3srbcr-0"
})(["height:100%;"]);
;// CONCATENATED MODULE: ./src/pages/ir/manage/disclosure.tsx


/***/ }),

/***/ 81610:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/manage/disclosure",
      function () {
        return __webpack_require__(75939);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,9181,5548,4535,9774,2888,179], function() { return __webpack_exec__(81610); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);